import React,{useState, useEffect, useRef, useContext} from 'react';
import RichTextEditor from 'react-rte';
import {Form} from 'react-bootstrap';
const RTEditor = (props) => {

  const toolbarConfig = {
    // Optionally specify the groups to display (displayed in the order listed).
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
    INLINE_STYLE_BUTTONS: [
      {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
      {label: 'Italic', style: 'ITALIC'},
      {label: 'Underline', style: 'UNDERLINE'}
    ],
    BLOCK_TYPE_DROPDOWN: [
      {label: 'Normal', style: 'unstyled'},
      {label: 'Heading Large', style: 'header-one'},
      {label: 'Heading Medium', style: 'header-two'},
      {label: 'Heading Small', style: 'header-three'}
    ],
    BLOCK_TYPE_BUTTONS: [
      {label: 'UL', style: 'unordered-list-item'},
      {label: 'OL', style: 'ordered-list-item'}
    ]
  };
  const [val,setVal] = useState(RichTextEditor.createValueFromString(props.value,'html'));

  useEffect(()=>{
    if(props.srcType){
      props.setDesc(val.toString('html'))     
    }
    if(props.idx >=0 && props.idx<6){
      props.setDesc({id:props.idx, expl:val.toString('html')})
    }
  },[val]);

  return <>
    <Form.Control name={props.name} as={props.as} className='d-none' value={val.toString('html')} />
    <RichTextEditor toolbarConfig={toolbarConfig} value={val} onChange={setVal} />
  </>;


};

export default RTEditor;